var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectorspecific({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-1568 -871)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(1568 871)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_041a8e2ba134dd26595940fb9992b6d5",
    "data-name": "041a8e2ba134dd26595940fb9992b6d5",
    transform: "translate(1573.465 877.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M27.266,18.832V47.45S11.59,40.742,5.021,37.94L5,37.907V9.306l.019.037,22.226,9.511Z",
    transform: "translate(0.002 4.598)",
    fill: "#3666f6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M38.741,9.3l-.019.035L16.5,18.853v28.6L38.724,37.94l.019-.035V9.3Z",
    transform: "translate(10.772 4.597)",
    fill: "#e2eaf4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M26.9,4.4,5,13.91v.023l22.27,9.555,22.28-9.577L27.5,4.4h-.6Z",
    transform: "translate(0 0)",
    fill: "#daf1f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M30.81,5.88l-.136.05L8.553,15.5V28.929l3.926-1.937L16.354,32.8l0-13.958L38.475,9.179Z",
    transform: "translate(3.329 1.388)",
    fill: "#494f54",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectorspecific);
export default __webpack_public_path__ + "static/media/sectorspecific.761d519e6c6792265b18682ed0a979d4.svg";
export { ForwardRef as ReactComponent };